import { render } from "./NavLinkMenu.vue?vue&type=template&id=0b277646&scoped=true"
import script from "./NavLinkMenu.vue?vue&type=script&lang=js"
export * from "./NavLinkMenu.vue?vue&type=script&lang=js"

import "./NavLinkMenu.vue?vue&type=style&index=0&id=0b277646&scoped=true&lang=scss"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b277646"]])

export default __exports__